module.exports = __webpack_public_path__ + "img/fas-expand-alt.fa5a97c8.svg";